import { ActionType, createReducer } from "typesafe-actions";
import * as actions from "store/features/creativeMappings/overivew/overview.actions";
import { resetApiError } from "store/features/general";
import { fetchCreativeMappings, toggleRowEdit } from "./overview.actions";
import { CreativeMappingsRuleForm } from "validation/components/CreativeMappings/creativeMappingsRules";
import {
    createCreativeMapping,
    deleteCreativeMapping,
    unsetCreativeMappingsRowEdit,
    updateCreativeMapping,
} from "store/features/creativeMappings/overivew/overview.actions";

export type CreativeMappingsAction = ActionType<typeof actions>;

export type CreativeMappingsListState = Readonly<{
    hasError: boolean;
    isDeleting: boolean;
    isSubmitted: boolean;
    isProcessing: boolean;
    creativeMappings: CreativeMappingsRuleForm[];
}>;

export const creativeMappingsInitialState: CreativeMappingsListState = {
    hasError: false,
    isProcessing: false,
    isSubmitted: false,
    isDeleting: false,
    creativeMappings: [],
};

export const overviewReducer = createReducer<CreativeMappingsListState, CreativeMappingsAction>(
    creativeMappingsInitialState
)
    .handleAction(
        [createCreativeMapping.request, fetchCreativeMappings.request, updateCreativeMapping.request],
        (state) => {
            return {
                ...creativeMappingsInitialState,
                creativeMappings: state.creativeMappings,
                isProcessing: true,
            };
        }
    )
    .handleAction(deleteCreativeMapping.request, (state) => {
        return {
            ...state,
            isDeleting: true,
        };
    })
    .handleAction(deleteCreativeMapping.success as never, (state) => {
        return {
            ...state,
            isDeleting: false,
        };
    })
    .handleAction(fetchCreativeMappings.success, (state, { payload }) => {
        return {
            ...state,
            isProcessing: false,
            creativeMappings: payload,
        };
    })
    .handleAction([createCreativeMapping.success, updateCreativeMapping.success] as never, (state) => {
        return {
            ...state,
            isProcessing: false,
            isSubmitted: true,
        };
    })
    .handleAction(
        [
            fetchCreativeMappings.failure,
            createCreativeMapping.failure,
            updateCreativeMapping.failure,
            deleteCreativeMapping.failure,
        ],
        (state) => {
            return {
                ...state,
                isProcessing: false,
                isDeleting: false,
                hasError: true,
            };
        }
    )
    .handleAction(resetApiError as never, (state) => {
        return {
            ...state,
            hasError: false,
        };
    })
    .handleAction(toggleRowEdit, (state, actions) => {
        return {
            ...state,
            creativeMappings: state.creativeMappings.map((mapping) => {
                if (actions.payload.id === mapping.id) {
                    return {
                        ...mapping,
                        isEdited: !mapping.isEdited,
                    };
                }

                return mapping;
            }),
        };
    })
    .handleAction(unsetCreativeMappingsRowEdit, (state) => {
        return {
            ...state,
            creativeMappings: state.creativeMappings.map((mapping) => {
                return {
                    ...mapping,
                    isEdited: false,
                };
            }),
        };
    });
